/* src/app/views/collection/shared/single-province-location-display-list-items/single-province-location-display-list-items.component.scss */
/*# sourceMappingURL=single-province-location-display-list-items.component.css.map */
